<img src="{{poster_image_path}}" width="100" height="100"/>
